import topBarLoader from "./topbar/loader";

export default function loadRiver(context) {
    if (!context.settings.useRiver) {
        return context;
    }
    topBarLoader(context);
    return context;
}
